module.exports = __webpack_public_path__ + "static/media/46.9b468278.webp";